import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { coordinateFields } from './common/coordinateFields';
import { msg } from '@lingui/core/macro';
import { volumeUnitField } from './common/sharedFields';
import { utilityCostFields } from './common/utilityCostFields';

export const waterConsumptionMetadata = {
  displayName: msg({
    message: 'Water consumption',
    context: 'Activity data schema name for water consumption',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...coordinateFields,
    ...buildingRevisionFields,
    ...utilityCostFields,
    quantity: {
      displayName: msg({
        message: 'Water consumption',
        context: 'The quantity of water consumed.',
      }),
      externalDescription: msg({
        message:
          'The quantity of water consumed, which is conceptually identical to water withdrawal minus water discharge, subject to changes in water storage.',
        context: 'Water consumed',
      }),
    },
    unit: volumeUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
